
import React from 'react'
import './index.css'
import generateImageUrlFromHighlightUtil from 'containers/QuickShopProductSidebar/Highlights/utils/generate-image-url-from-highlight/index.js'

const HIGHLIGHTS = 'highlights'

const Highlights = ({ highlights }) => {
  const highlightsSeparated = highlights.trim().split('|').filter(Boolean)

  return (
    <div className='highlights'>
      <div className='highlight-heading'>{HIGHLIGHTS}</div>
      <div className='highlight-main-container'>
        {
          highlightsSeparated?.map((highlight, index) => {
            return (
              <div key={index} className='highlight-row-container'>
                <img className='highlight-icon' src={generateImageUrlFromHighlightUtil(highlight)} />
                <div className='highlight-text'>{highlight}</div>
              </div>
            )
          })
        }
      </div>

    </div>
  )
}

export default Highlights
